module.exports = __webpack_public_path__ + "media/src/images/global-stats-numbers-default-730fc616354f43a38e9ac7c4d86064dd.png";